"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var ButtonBase_1 = __importDefault(require("@material-ui/core/ButtonBase"));
var SvgFlame_1 = __importDefault(require("../PortexIcons/SvgFlame"));
var useStyles = styles_1.makeStyles(function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            display: "inline-flex",
            alignItems: "center",
            borderRadius: 4,
            padding: "2px 8px",
        },
        filled: {
            backgroundColor: palette.grey[100],
        },
        outlined: {
            border: "1px solid",
            borderColor: palette.grey["200"],
            backgroundColor: palette.background.paper,
        },
        hazardous: {
            color: palette.error.main,
            marginLeft: 4,
        },
        flame: {
            marginLeft: 6,
        },
        group: {
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            margin: -4,
        },
        item: {
            padding: 4,
        },
        delete: {
            marginLeft: 4,
            marginRight: -5,
            borderRadius: 2,
            color: palette.text.secondary,
            "&:hover, &:focus": {
                color: palette.text.primary,
            },
        },
    });
}, { name: "CommodityTag" });
function DeleteIcon() {
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", height: "1.25em", width: "1.25em", fontSize: "inherit", fill: "currentColor" },
        react_1.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
        react_1.default.createElement("path", { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" })));
}
var CommodityTag = react_1.default.forwardRef(function CommodityTag(_a, ref) {
    var isHazardous = _a.isHazardous, className = _a.className, children = _a.children, onDelete = _a.onDelete, deleteIcon = _a.deleteIcon, _b = _a.variant, variant = _b === void 0 ? "outlined" : _b, props = __rest(_a, ["isHazardous", "className", "children", "onDelete", "deleteIcon", "variant"]);
    var styles = useStyles();
    return (react_1.default.createElement("div", __assign({ ref: ref, className: clsx_1.default(styles.root, styles[variant], className) }, props),
        children,
        isHazardous && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(SvgFlame_1.default, { className: styles.flame }),
            react_1.default.createElement("span", { className: styles.hazardous }, "Hazardous"))),
        typeof onDelete === "function" && (react_1.default.createElement(ButtonBase_1.default, { onClick: onDelete, className: styles.delete }, deleteIcon !== null && deleteIcon !== void 0 ? deleteIcon : react_1.default.createElement(DeleteIcon, null)))));
});
var Group = function (_a) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    var styles = useStyles();
    return (react_1.default.createElement("div", __assign({ className: clsx_1.default(styles.group, className) }, props), react_1.default.Children.map(children, function (child) { return (react_1.default.createElement("div", { className: styles.item }, child)); })));
};
CommodityTag.Group = Group;
exports.default = CommodityTag;
//# sourceMappingURL=CommodityTag.js.map